import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createSlots as _createSlots, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2f45e485")

_pushScopeId("data-v-2f45e485")
const _hoisted_1 = { class: "space-y-6 pb-8 mr-8" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "text-14px text-gray-lp-600 mt-2 mb-8" }, " Anda bisa mengaktifkan status ini kapan saja ", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_Toggle = _resolveComponent("Toggle")!
  const _component_ChipsV2 = _resolveComponent("ChipsV2")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!

  return (_openBlock(), _createBlock(_component_DetailLayout, {
    onBack: _ctx.goBack,
    title: _ctx.detailData.configurablePriceName,
    "custom-class": "px-0",
    loading: _ctx.detailEntities.loading,
    error: !!_ctx.detailEntities.message,
    errorType: _ctx.detailEntities.message,
    onTryAgain: _ctx.fetchDetail,
    verticalSeparator: !_ctx.isEdit,
    "leave-page-confirmation": _ctx.leavePageConfirmation,
    "onUpdate:leave-page-confirmation": _cache[4] || (_cache[4] = ($event: any) => (_ctx.leavePageConfirmation = $event)),
    onLeavePage: _ctx.onLeavePage
  }, _createSlots({
    data: _withId(() => [
      _createVNode("div", _hoisted_1, [
        (!_ctx.isEdit)
          ? (_openBlock(), _createBlock(_component_DataWrapper, {
              key: 0,
              label: "ID Konfigurable",
              value: _ctx.detailData.configurablePriceId
            }, null, 8, ["value"]))
          : _createCommentVNode("", true),
        _createVNode(_component_DataWrapper, {
          label: "Nama Konfigurasi Biaya",
          value: !_ctx.isEdit ? _ctx.detailData.configurablePriceName : ''
        }, {
          default: _withId(() => [
            (_ctx.isEdit)
              ? (_openBlock(), _createBlock(_component_LpInput, {
                  key: 0,
                  modelValue: _ctx.detailData.configurablePriceName,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.detailData.configurablePriceName = $event)),
                  disabled: _ctx.isEdit
                }, null, 8, ["modelValue", "disabled"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["value"]),
        _createVNode(_component_DataWrapper, {
          label: "Deskripsi",
          value: !_ctx.isEdit ? _ctx.detailData.configurablePriceDescription : '',
          optional: _ctx.isEdit
        }, {
          default: _withId(() => [
            (_ctx.isEdit)
              ? (_openBlock(), _createBlock(_component_LpInput, {
                  key: 0,
                  modelValue: _ctx.detailData.configurablePriceDescription,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.detailData.configurablePriceDescription = $event)),
                  type: "textarea",
                  placeholder: "Masukkan deskripsi"
                }, null, 8, ["modelValue"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["value", "optional"]),
        _createVNode(_component_TableV2, {
          data: _ctx.detailData.configurableCod,
          columns: _ctx.columns,
          hidePagination: "",
          borderTop: false,
          borderBottom: false
        }, null, 8, ["data", "columns"]),
        (_ctx.isEdit)
          ? (_openBlock(), _createBlock(_component_DataWrapper, {
              key: 1,
              label: "Status Konfigurasi Biaya"
            }, {
              default: _withId(() => [
                _hoisted_2,
                _createVNode(_component_Toggle, {
                  modelValue: _ctx.detailData.isConfigurablePriceStatus,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.detailData.isConfigurablePriceStatus = $event)),
                  textActive: "Aktif",
                  textInactive: "Tidak Aktif"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 2
  }, [
    (_ctx.isEdit)
      ? {
          name: "top-right",
          fn: _withId(() => [
            _createVNode(_component_LpButton, {
              title: "Simpan",
              onClick: _ctx.onConfirmSave,
              textColor: "white",
              disabled: _ctx.isDisabled
            }, null, 8, ["onClick", "disabled"])
          ])
        }
      : undefined,
    (!_ctx.isEdit)
      ? {
          name: "sub-data",
          fn: _withId(() => [
            _createVNode(_component_DataWrapper, { label: "Status Konfigurasi Biaya" }, {
              default: _withId(() => [
                _createVNode(_component_ChipsV2, {
                  label: _ctx.detailData.configurablePriceStatus
                }, null, 8, ["label"])
              ]),
              _: 1
            }),
            _createVNode(_component_DataWrapper, {
              label: "Tanggal Dibuat",
              value: 
          _ctx.detailData.formatDate
            ? _ctx.detailData.formatDate(_ctx.detailData.configurablePriceCreatedAt)
            : ''
        ,
              caption: _ctx.detailData.configurablePriceCreatedBy
            }, null, 8, ["value", "caption"]),
            _createVNode(_component_DataWrapper, {
              label: "Terakhir Diperbarui",
              value: 
          _ctx.detailData.formatDate
            ? _ctx.detailData.formatDate(_ctx.detailData.configurablePriceUpdatedAt)
            : ''
        ,
              caption: _ctx.detailData.configurablePriceUpdatedBy
            }, null, 8, ["value", "caption"]),
            _createVNode(_component_LpButton, {
              title: "Ubah",
              onClick: _ctx.goEdit,
              textColor: "white"
            }, null, 8, ["onClick"])
          ])
        }
      : undefined
  ]), 1032, ["onBack", "title", "loading", "error", "errorType", "onTryAgain", "verticalSeparator", "leave-page-confirmation", "onLeavePage"]))
})